"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scale = void 0;
var fraction_1 = require("./fraction");
var Scale = function (number, unit, scale) {
    var scaleString = (scale * 100000) + '/100000';
    var result = fraction_1.Fraction.multiply(number, scaleString);
    return {
        quantity: result,
        unit: unit
    };
};
exports.Scale = Scale;
